import React from 'react';
import * as FiIcons from 'react-icons/fi';
import { FaSpotify, FaApple, FaYoutube } from 'react-icons/fa';

const LINKS = [
  {
    label: 'Apple Podcasts',
    href: 'https://podcasts.apple.com/us/podcast/roots-and-branches-adoption-stories-podcast/id1852411277',
    icon: FaApple,
    bg: 'hover:bg-[#fc3c44]/10',
    color: 'text-[#fc3c44]',
    border: 'border-[#fc3c44]/20 hover:border-[#fc3c44]/50',
  },
  {
    label: 'Spotify',
    href: 'https://open.spotify.com/show/1mCXLrJj0teRWXikwQjZ0W?si=32129bbdda8e40eb&nd=1&dlsi=04d59576a8b34e8f',
    icon: FaSpotify,
    bg: 'hover:bg-[#1DB954]/10',
    color: 'text-[#1DB954]',
    border: 'border-[#1DB954]/20 hover:border-[#1DB954]/50',
  },
  {
    label: 'YouTube',
    href: 'https://www.youtube.com/playlist?list=PL5bEz6eL_xgmAToWw1Qc9YkAHERh1Kfe5',
    icon: FaYoutube,
    bg: 'hover:bg-[#FF0000]/10',
    color: 'text-[#FF0000]',
    border: 'border-[#FF0000]/20 hover:border-[#FF0000]/50',
  },
];

const SubscribeLinks = () => (
  <div className="flex flex-wrap items-center justify-center gap-2 mt-4 mb-1">
    <span className="text-[9px] font-bold uppercase tracking-widest text-brand-green/40 mr-1">
      Listen on
    </span>
    {LINKS.map(({ label, href, icon: Icon, bg, color, border }) => (
      <a
        key={label}
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full border text-[10px] font-bold uppercase tracking-wider transition-all duration-200 bg-white ${bg} ${color} ${border}`}
      >
        <Icon className="w-3 h-3" />
        {label}
      </a>
    ))}
  </div>
);

export default SubscribeLinks;